import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {PipeModule} from '@shared/pipes/pipe.module';
import {LoadingComponent} from '@app/components/loading/loading.component';
import {ZorroModule} from '@shared/zorro.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ZorroModule,
    PipeModule
  ],
  declarations: [LoadingComponent],
  exports: [
    LoadingComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ZorroModule, PipeModule
  ],
  providers: [
  ]
})
export class SharedModule {
}
